import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames/bind';
import { colorVars, colorLongToShort, getCssColorFromColorName, } from '../../../utils/colors';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const SIZES_MAP = {
    mini: 12,
    tiny: 14,
    small: 16,
    large: 18,
    big: 20,
    huge: 24,
    massive: 30,
};
export const SIZES = _.keys(SIZES_MAP);
const WEIGHTS_MAP = {
    normal: 400,
    medium: 600,
    heavy: 700,
    black: 900,
};
export const WEIGHTS = _.keys(WEIGHTS_MAP);
export const COLOR_NAMES = _.keys(colorVars).map(colorLongToShort);
const Text = forwardRef((props, ref) => {
    const { as: Component = 'div', children, className, color = 'grayDark', content, size = 'small', weight = 'normal', elmId, style, ...rest } = props;
    const newStyle = {
        color: getCssColorFromColorName(color),
        fontSize: SIZES_MAP[size],
        fontWeight: WEIGHTS_MAP[weight],
    };
    return (_jsx(Component, { ref: ref, "data-elm-id": elmId, className: cx('text', className), style: { ...newStyle, ...style }, ...rest, children: content || children }));
});
const HEADER_LEVELS_MAP = {
    1: { as: 'h1', size: 'massive' },
    2: { as: 'h2', size: 'huge' },
    3: { as: 'h3', size: 'big' },
};
export const HEADER_LEVELS = _.keys(HEADER_LEVELS_MAP);
const TextHeader = forwardRef(({ className, level = 1, compact = false, as, ...rest }, ref) => {
    return (_jsx(Text, { ref: ref, weight: 'heavy', className: cx(className, `header-${level}`, { compact }), size: HEADER_LEVELS_MAP[level]?.size, as: as || HEADER_LEVELS_MAP[level]?.as, ...rest }));
});
const TextHeaderWithStatics = TextHeader;
TextHeaderWithStatics.getSizeInPixels = (level) => SIZES_MAP[HEADER_LEVELS_MAP[level].size];
const BODY_SIZE_MAP = {
    large: 'large',
    normal: 'small',
    small: 'tiny',
    extraSmall: 'mini',
};
const TextBody = forwardRef(({ size = 'normal', ...rest }, ref) => (_jsx(Text, { ...rest, size: BODY_SIZE_MAP[size], ref: ref })));
const TextBodyWithStatics = TextBody;
TextBodyWithStatics.getSizeInPixels = (size) => SIZES_MAP[BODY_SIZE_MAP[size]];
const textPropTypes = {
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.oneOf(COLOR_NAMES),
    content: PropTypes.node,
    size: PropTypes.oneOf(SIZES),
    weight: PropTypes.oneOf(WEIGHTS),
    elmId: PropTypes.string,
    style: PropTypes.object,
};
const TextWithStatics = Text;
TextWithStatics.Body = TextBodyWithStatics;
TextWithStatics.Header = TextHeaderWithStatics;
TextWithStatics.propTypes = textPropTypes;
TextWithStatics.getWeightInNumericalTerms = weight => WEIGHTS_MAP[weight];
TextWithStatics.getSizeInPixels = size => SIZES_MAP[size];
export default TextWithStatics;
//# sourceMappingURL=index.js.map